import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { AppBar, Toolbar, Grid, IconButton, Button } from '@mui/material';
import { AccountCircleOutlined, ArrowDropDown } from '@mui/icons-material';
import { styled, useTheme } from '@mui/material/styles';
import { useCombinedRefs } from 'utilities/refFns';

import Menu from 'components/library/navigation/Menu';
import Restricted from 'components/library/routing/Restricted';

const ListButton = styled(Button)(({ theme }) => {
    return ({
        color: theme.palette.getContrastText(theme.palette.header.background),
        backgroundColor: theme.palette.header.background,
        fontSize: theme.typography.body2.fontSize,
        fontWeight: theme.typography.body2.fontWeight,
        fontFamily: theme.typography.body2.fontFamily,
        '&:hover': {
            backgroundColor: theme.palette.grey[800],
        }
    })
});

const MenuButton = styled(Button)(({ theme }) => {
    return ({
        color: theme.palette.getContrastText(theme.palette.header.background),
        backgroundColor: theme.palette.header.background,
        fontSize: theme.typography.body2.fontSize,
        fontWeight: theme.typography.body2.fontWeight,
        fontFamily: theme.typography.body2.fontFamily,
        '&:hover': {
            backgroundColor: theme.palette.grey[800],
        },
        'border': '1px solid rgba(63, 81, 181, 0.5)'
    })
});

const HeaderLink = React.forwardRef((props, ref) => {
    let theme = useTheme();
    const navLinkTheme = {
        navLink: {
            display: 'block',
            position: 'relative',
            fontSize: theme.typography.header.fontSize,
            fontWeight: theme.typography.header.fontWeight,
            top: theme.spacing(0.24),
            textDecoration: "initial",
            color: theme.palette.getContrastText(theme.palette.header.background),
            backgroundColor: theme.palette.header.background
        }
    };

    const innerRef = useRef();
    const combinedRef = useCombinedRefs(ref, innerRef);

    return <Link {...props} ref={combinedRef} style={navLinkTheme.navLink} />
})

const HeaderBar = ({ logo, title, renderMenus, userName, logoutHandler }) => {
    let theme = useTheme();
    const headerBarStyles = {
        grow: {
            flexGrow: 1
        },
        logo: {
            display: 'block',
            position: 'relative',
            paddingRight: theme.spacing(2),
            top: theme.spacing(0.24)
        },
        pad: {
            paddingLeft: theme.spacing(2)
        },
        appBar: {
            background: theme.palette.header.background,
            color: theme.palette.common.white
        }
    };

    const RestrictedMenuItem = ({ allowFor, children }) => {
        if (allowFor) return <Restricted allowFor={allowFor}>{children}</Restricted>;
        return children;
    }

    const renderMenuItems = () => {
        const menus = renderMenus && renderMenus();

        return menus
            ? menus.filter((item) => item !== undefined && item !== null)
                .map((item) => {
                    const renderItem =
                        item.type === 'button'
                            ? <ListButton key={item.label} variant="outlined" onClick={(e) => item.action(e)}>{item.label}</ListButton>
                            : item.type === 'menu' && item.items?.filter((child) => !child.isHidden).length !== 0
                                ? <Menu
                                    key={item.label}
                                    menuItems={item.items?.filter((child) => !child.isHidden)}
                                    renderButton={(props) => <MenuButton {...props} variant="outlined">{item.label}</MenuButton>} />
                                : item.type === 'divide'
                                    ? <div style={headerBarStyles.grow} />
                                    : null;

                    return (
                        <RestrictedMenuItem allowFor={item.allowFor}>
                            {renderItem}
                        </RestrictedMenuItem>
                    )
                })
            : [];
    }

    // return menu.items ? <Menu buttonLabel={menu.key} menuItems={menu.items} /> : menu.button ? <Button onClick={(e) => menu.button.action(e)}>{menu.button.label}</Button> : <div className={classes.grow} />
    const createAccountMenuItems = [
        { label: "Logout", action: () => logoutHandler() }
    ]

    const renderAccountButton = (props) => {
        return <div title={userName}>
            <IconButton {...props} color="inherit">
                <AccountCircleOutlined />
                <ArrowDropDown />
            </IconButton>
        </div>
    }

    return (
        <AppBar style={headerBarStyles.appBar} position="static">
            <Toolbar variant="dense">
                <div style={headerBarStyles.logo}>
                    {logo && <img src={logo} id="appicon" alt="Leonardo" />}
                </div>

                <Grid container justifyContent="flex-start" alignContent="stretch" alignItems="baseline">
                    <Grid container item xs={6}>
                        <Grid item>
                            <Button to="/" size="small" title={title} component={HeaderLink}>
                                {title}
                            </Button>
                        </Grid>
                    </Grid>

                    <Grid item xs={6}>
                        <Grid container justifyContent="flex-end" alignContent="stretch" alignItems="baseline">
                            {renderMenuItems().filter((item) => item !== null).map((item, index) => (
                                <Grid key={`test_${index}`} item style={headerBarStyles.pad}>{item}</Grid>
                            ))}
                        </Grid>
                    </Grid>
                </Grid>

                <div style={headerBarStyles.grow} />

                <Menu
                    renderButton={(innerProps) => renderAccountButton(innerProps)}
                    menuItems={createAccountMenuItems}
                />
            </Toolbar>
        </AppBar>
    );
}

export default HeaderBar;